export enum StatusCellEnum {
  ACTIVE = 'active',
  CONFIRMED = 'confirmed',
  APPROVAL = 'approval',
  CANCELED = 'canceled',
  CLOSED = 'closed',
}
